import { render, staticRenderFns } from "./ShopSensitiveAttr.vue?vue&type=template&id=018ad223&scoped=true"
import script from "./ShopSensitiveAttr.vue?vue&type=script&lang=js"
export * from "./ShopSensitiveAttr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ad223",
  null
  
)

export default component.exports